import script from "./alumni-form.vue?vue&type=script&setup=true&lang=js"
export * from "./alumni-form.vue?vue&type=script&setup=true&lang=js"

import "./alumni-form.vue?vue&type=style&index=0&id=342400f4&lang=css"

const __exports__ = script;

export default __exports__